import script from "./DeathClaimTrackerListViewDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DeathClaimTrackerListViewDialog.vue?vue&type=script&setup=true&lang=js"

import "./DeathClaimTrackerListViewDialog.vue?vue&type=style&index=0&id=3d402bf2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d402bf2"]])

export default __exports__